import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useFetchDialogue } from '../DialogueEditor/use-fetch-dialogue';
import { Spinner } from '@mm/components';
import { useSelector } from 'react-redux';
import { selectCampaignById } from '@mm/state/selectors/campaignSelectors';
import { useCampaignCRUDActions } from '@mm/state/actions/CampaignsCRUDActions';
import { selectWidgetsByDialogueId } from '@mm/state/selectors/widgetSelectors';
import WidgetModel from '@mm/state/model/WidgetModel';
import { widgetToNodeType } from '../DialogueEditor/use-graph';
import { getNode } from '../DialogueEditor/NodeTypes';
import { Adder } from '../DialogueEditor/NodeTypes/Adder/Adder';
import { DialogueEditor } from '../DialogueEditor/DialogueEditor';

type Props = {
  className?: string;
  campaignId: number;
};

const Widget = ({ widget, ...rest }: { widget: WidgetModel }) => {
  const type = widgetToNodeType(widget);
  const Component = getNode(type);

  if (!Component) {
    return null;
  }

  // @ts-ignore
  return <Component data={{ widget, ...rest }} />;
};

export const CampaignDialogueEditor = ({ className, campaignId }: Props) => {
  const storeCampaign = useSelector(state =>
    selectCampaignById(state, campaignId || -1),
  );

  const schedulerAttributes = storeCampaign?.schedulersAttributes?.[0];
  const { destinationPageId: dialogueId, destinationPageGroupId: pageGroupId } =
    schedulerAttributes || {};

  const campaignCRUDActions = useCampaignCRUDActions();
  useEffect(() => {
    campaignCRUDActions.retrieve(campaignId);
  }, []);

  const [elements, setElements] = useState([]);

  const onChange = (_, elements) => {
    setElements(elements);
  };

  return (
    <div className={classNames(className)}>
      {dialogueId && campaignId && (
        <DialogueEditor
          dialogueId={dialogueId}
          campaignId={campaignId}
          pageGroupId={pageGroupId}
          schedulerDateTimeVisible={false}
          scheduledAt=""
          intervalInMin={0}
          onPaneClick={() => {}}
          onMoveStart={() => {}}
          onChange={onChange}
          withBackground={false}
          paneMoveable={false}
          bottomYCompensation={30}
        />
      )}
    </div>
  );
};
